import { getMemberPrivacySettings as getMemberPrivacySettingsAmbassador } from '@wix/ambassador-members-v1-member-privacy-settings/http';
import { Candidates } from '@wix/ambassador-members-v1-member-privacy-settings/types';
import { withResolvedError } from '@wix/members-area-commons-ts';

import type { ErrorHandler, HttpClient } from '../types/controller';

export type MemberPrivacyFlags = {
  isPublicMemberCandidateNoOne: boolean;
  isSiteSocial: boolean;
};

const getPublicMemberCandidates = async (
  httpClient: HttpClient,
  errorHandler: ErrorHandler,
) => {
  const requestFn = () =>
    httpClient.request(getMemberPrivacySettingsAmbassador({}));

  const {
    data: { memberPrivacySettings },
  } = await withResolvedError(requestFn, errorHandler, {
    errorCodesMap: {},
  });

  return memberPrivacySettings?.publicMemberCandidates;
};

export const getMemberPrivacyFlags = async (
  httpClient: HttpClient,
  errorHandler: ErrorHandler,
): Promise<MemberPrivacyFlags> => {
  const candidates = await getPublicMemberCandidates(httpClient, errorHandler);

  return {
    isPublicMemberCandidateNoOne: candidates === Candidates.NO_ONE,
    isSiteSocial: candidates === Candidates.ANYONE,
  };
};

export const getIsPublicMemberCandidateNoOne = async (
  httpClient: HttpClient,
  errorHandler: ErrorHandler,
) => {
  const candidates = await getPublicMemberCandidates(httpClient, errorHandler);
  return candidates === Candidates.NO_ONE;
};

export const getIsSiteSocial = async (
  httpClient: HttpClient,
  errorHandler: ErrorHandler,
) => {
  const candidates = await getPublicMemberCandidates(httpClient, errorHandler);
  return candidates === Candidates.ANYONE;
};
